import { useTranslation } from "react-i18next";
import { ChevronRight, Columns3Cog } from "lucide-react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

type MenuItem = {
  value: string;
  label: string;
};

interface GroupByProps {
  menus: MenuItem[];
  selected: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

const GroupBy = ({ menus, selected, onChange, onClose }: GroupByProps) => {
  const { t } = useTranslation();

  const selectData = menus.find((item) => item.value === selected);

  return (
    <div>
      <Popover>
        <PopoverButton className="w-full flex items-center justify-between space-x-2 p-2 cursor-default rounded-md hover:bg-gray-100 outline-none">
          <div className="flex items-center space-x-2">
            <div>
              <Columns3Cog className="w-5 h-5" />
            </div>
            <div className="text-nowrap text-sm font-medium">
              <span>{t("Grouped by")}</span>
              <span className="pl-2 text-gray-500">{selectData?.label}</span>
            </div>
          </div>
          <div className="flex items-center justify-end">
            <ChevronRight className="w-4 h-4" />
          </div>
        </PopoverButton>
        <PopoverPanel anchor="right start" className="[--anchor-gap:12px] z-20">
          {({ close }) => (
            <div className="w-max max-h-120 overflow-y-auto p-2 rounded-md bg-white border border-gray-300">
              {menus.map((item) => {
                return (
                  <button
                    key={item.value}
                    className="block w-full px-3 py-2 text-left text-sm font-medium hover:bg-gray-100"
                    onClick={() => {
                      onChange(item.value);
                      close();
                      onClose();
                    }}
                  >
                    {item.label}
                  </button>
                );
              })}
            </div>
          )}
        </PopoverPanel>
      </Popover>
    </div>
  );
};

export default GroupBy;
